module.exports = __webpack_public_path__ + "img/bg_zc.ba66466f.svg";